module.exports = "/_next/static/images/6aab4d2ce0ce74a75b4a4ca2cb094c7f-monthly-payments-xs.jpg.webp";